var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrosIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2743_125109)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FF5555",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5057 13.1456V12.1444L11.652 12.9985L8.28513 16.3674C8.28509 16.3674 8.28506 16.3674 8.28503 16.3675C8.20011 16.4523 8.08496 16.5 7.9649 16.5C7.84479 16.5 7.7296 16.4523 7.64467 16.3674C7.55974 16.2824 7.51203 16.1672 7.51203 16.0471C7.51203 15.927 7.55973 15.8119 7.64464 15.7269C7.64465 15.7269 7.64466 15.7269 7.64467 15.7269L11.0129 12.3593L11.3666 12.0057L11.0129 11.6521L7.644 8.28384L7.64405 8.28379L7.63801 8.27794C7.5948 8.23618 7.56035 8.18622 7.53666 8.13099C7.51297 8.07577 7.50051 8.01638 7.50002 7.95629C7.49952 7.89619 7.511 7.83661 7.53378 7.781C7.55656 7.72539 7.59019 7.67488 7.6327 7.6324C7.67522 7.58993 7.72576 7.55635 7.78139 7.53362C7.83702 7.51089 7.89662 7.49947 7.95671 7.50002C8.0168 7.50057 8.07618 7.51308 8.13139 7.53683C8.18659 7.56057 8.23651 7.59507 8.27824 7.63832L8.27818 7.63837L8.28449 7.64468L11.6521 11.0123L12.0057 11.3659L12.3593 11.0123L15.7263 7.64465L15.7263 7.6446C15.7684 7.60255 15.8182 7.5692 15.8732 7.54644C15.9281 7.52368 15.9869 7.51196 16.0464 7.51194C16.1058 7.51193 16.1647 7.52362 16.2196 7.54636C16.2745 7.56909 16.3244 7.60242 16.3665 7.64444C16.4085 7.68647 16.4419 7.73636 16.4646 7.79127C16.4874 7.84618 16.4991 7.90504 16.4991 7.96449C16.4991 8.02393 16.4874 8.08279 16.4647 8.13771C16.442 8.19264 16.4086 8.24255 16.3666 8.28459L12.9985 11.6521L12.6448 12.0057L12.9985 12.3593L16.3673 15.7269C16.4523 15.8118 16.5 15.927 16.5 16.0471C16.5 16.1672 16.4523 16.2824 16.3673 16.3674C16.2824 16.4523 16.1672 16.5 16.0471 16.5C15.927 16.5 15.8118 16.4523 15.7269 16.3674C15.7269 16.3674 15.7269 16.3674 15.7269 16.3674L12.5057 13.1456Z",
    fill: "#ED4650",
    stroke: "#ED4650"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2743_125109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrosIconRed);
export default __webpack_public_path__ + "static/media/cros-icon-red.ad738880f682967e0583478556335edd.svg";
export { ForwardRef as ReactComponent };